import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth.service';
import { FenetreService } from '../../@core/utils/fenetre-service';


@Injectable()
export class AutoLogoutService {


  constructor(private router: Router, private authService: AuthService, private fenetreService: FenetreService) {

    // pour que sa marche, il faut appéler le service dans un constructeur ( constructeur du app.ts par exemple ) 
    this.check();
    this.initListener();
    this.initInterval();
    localStorage.setItem(this.authService.storekey(), Date.now().toString());
  }

  initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover', () => this.reset());
    document.body.addEventListener('mouseout', () => this.reset());
    document.body.addEventListener('keydown', () => this.reset());
    document.body.addEventListener('keyup', () => this.reset());
    document.body.addEventListener('keypress', () => this.reset());
  }

  reset() {
    this.authService.setLastAction(Date.now());
    // tslint:disable-next-line:no-console
    // console.log('initilisation');
  }

  initInterval() {
    setInterval(() => {
      this.check();
      // tslint:disable-next-line:no-console
      // console.log('check');
    }, this.authService.checkinterval());
  }

  check() {

    if (this.authService.isTimeout())  {
      // localStorage.clear(); // il est préférable de plutot vérifier si l'utilisateur est sur la page login avant d'éffectuer l'action

      // on ne deconnecte pas automatiquement les fenêtres popups
      if (this.fenetreService.findnames(window.name) !== null )
      return;

      this.authService.logout();
      // alert('logout');
    }

  }



}
